import { Box, Button, Checkbox, Divider, Drawer, Grid, IconButton, InputAdornment, Paper, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material"
import { FC, useEffect, useRef, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import { formatDate } from "../../../../toolbox/helpers/formatDateHelper"
import { moneyCL } from "../../../../toolbox/helpers/money-helpers"
import { ApiStatus } from "../../../../types/api/status"
import { useAccountReceivableStore } from "../../../../hooks/useAccountReceivableStore"
import { PaymentVoucherFormData } from "./PaymentVoucherFormDrawer"
import { ModalConfirm } from "../../../../components/common/ModalConfirm/ModalConfirm"
import '../../../../assets/styles/facturacionv3-app.css'
import SearchIcon from '@mui/icons-material/Search'
import { withStyles } from '@mui/styles';
import { CustomSnackbar } from "../../../../components/common/CustomSnackbar/CustomSnackbar"

interface Props {
    open: boolean
    onClose: () => void
    PaymentVoucher: PaymentVoucherFormData
    onClose2: () => void
    onList: () => Promise<void>
}

interface onList {
    page?: number
    perPage?: number
    idsupplier?: number
    search?: string
    paid?: number
    order?: string
    orderBy?: string
}

const StyledTableCell = withStyles((theme) => ({
    head: {
        color: theme.palette.common.black,
        backgroundColor: '#69ABC3'
    },
    body: {
        fontSize: 14,
        padding: '4px 8px'
    },
}))(TableCell)

export const AccountReceivableListDrawer: FC<Props> = (props) => {
    const { open, onClose, PaymentVoucher, onList, onClose2 } = props

    const { status: statusAccounts, accounts, totalRows, getAccountsReceivable, payAccountsReceivables } = useAccountReceivableStore()

    const [search, setSearch] = useState<string>('')
    const [page, setPage] = useState<number>(1)
    const [perPage, setPerPage] = useState<number>(10)

    const [selectedRows, setSelectedRows] = useState<any[]>([])
    const [allSelected, setAllSelected] = useState<boolean>(false)
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false)

    const [dataTable, setDataTable] = useState<any[]>([])
    const [totalDebt, setTotalDebt] = useState<number>(0)
    const [totalAmount, setTotalAmount] = useState<number>(PaymentVoucher?.amount || 0)

    const checkboxRefs = useRef<(HTMLInputElement | null)[]>([])
    const searchRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (accounts.length > 0) {
            let remainingAmount = PaymentVoucher?.amount || 0
            let selected: any[] = []

            let updatedData = accounts.map(row => {
                if (remainingAmount > 0) {
                    const amountToPay = Math.min(row.debt, remainingAmount)
                    remainingAmount -= amountToPay
                    selected.push({ ...row, amount_pay: amountToPay })
                    return { ...row, amount_pay: amountToPay }
                }
                return { ...row, amount_pay: 0 }
            })

            setSelectedRows(selected)
            setAllSelected(selected.length === accounts.length)
            setDataTable(updatedData)
            setTotalAmount(remainingAmount)

            const totalDebt = accounts.reduce((acc, row) => acc + row.debt, 0)
            setTotalDebt(totalDebt)
        }
    }, [accounts, PaymentVoucher.amount])

    useEffect(() => {
        if (search === '') {
            getDataAPI()
        } else {
            const timer = setTimeout(() => getDataAPI(), 500)
            return () => clearTimeout(timer)
        }
    }, [search, page, perPage])

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            const focusedIndex = checkboxRefs.current.findIndex((checkbox) => document.activeElement === checkbox)

            if (event.key === 'ArrowDown' && focusedIndex < checkboxRefs.current.length - 1) {
                event.preventDefault()
                checkboxRefs.current[focusedIndex + 1]?.focus()
            }

            if (event.key === 'ArrowUp' && focusedIndex > 0) {
                event.preventDefault()
                checkboxRefs.current[focusedIndex - 1]?.focus()
            }

            if (event.key === 'Enter' && focusedIndex !== -1) {
                event.preventDefault()
                checkboxRefs.current[focusedIndex]?.click()
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Shift') {
                searchRef.current?.focus()
                setSearch('')
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [])


    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'F2') {
                event.preventDefault()
                onAdd()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const getDataAPI = async () => {
        const payload: onList = {
            page: page,
            perPage: perPage,
            idsupplier: PaymentVoucher.idsupplier,
            paid: 0,
            orderBy: 'deadline',
            order: 'asc'
        }
        if (search !== '') payload.search = search
        await getAccountsReceivable(payload)
    }

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage + 1)
    }

    const handleChangeRowsPerPage = (event) => {
        setPerPage(+event.target.value)
        setPage(1)
    }

    const onSearch = (search) => {
        setSearch(search)
    }

    const isSelected = (row: any) => selectedRows.some(selectedRow => selectedRow.id === row.id)

    const onCheckbox = (row: any) => {
        let updatedSelectedRows = [...selectedRows]
        let updatedDataTable = [...dataTable]
        let updatedTotalAmount = totalAmount

        const rowIndex = updatedSelectedRows.findIndex(selectedRow => selectedRow.id === row.id)

        if (rowIndex === -1) {
            const amountToPay = Math.min(row.debt, updatedTotalAmount)
            if (amountToPay > 0) {
                updatedSelectedRows.push({ ...row, amount_pay: amountToPay })
                updatedDataTable = updatedDataTable.map(item =>
                    item.id === row.id ? { ...item, amount_pay: amountToPay } : item
                )
                updatedTotalAmount -= amountToPay
            } else {
                CustomSnackbar('error', 'Saldo insuficiente')
            }
        } else {
            updatedTotalAmount += row.amount_pay
            updatedSelectedRows.splice(rowIndex, 1)
            updatedDataTable = updatedDataTable.map(item =>
                item.id === row.id ? { ...item, amount_pay: 0 } : item
            )
        }

        setSelectedRows(updatedSelectedRows)
        setDataTable(updatedDataTable)
        setTotalAmount(updatedTotalAmount)
    }

    const selectAllRows = () => {
        if (allSelected) {
            setSelectedRows([])
            setTotalAmount(PaymentVoucher?.amount || 0)
            setDataTable(dataTable.map(row => ({ ...row, amount_pay: 0 })))
        } else {
            let remainingAmount = PaymentVoucher?.amount || 0
            const updatedSelection = dataTable.map(row => {
                if (remainingAmount > 0) {
                    const amountToPay = Math.min(row.debt, remainingAmount)
                    remainingAmount -= amountToPay
                    return { ...row, amount_pay: amountToPay }
                }
                return { ...row, amount_pay: 0 }
            })

            setSelectedRows(updatedSelection.filter(row => row.amount_pay > 0))
            setTotalAmount(remainingAmount)
            setDataTable(updatedSelection)
        }
        setAllSelected(!allSelected)
    }

    const onAdd = () => {
        setShowConfirmDialog(true)
    }

    const onConfirmPay = async () => {
        const resp = await payAccountsReceivables({
            account_receivable: selectedRows?.map(row => ({
                id: row.id,
                amount_pay: row.amount_pay
            })) || [],
            payment_voucher: [PaymentVoucher]
        })
        if (resp === true) {
            onList()
            onClose()
            onClose2()
        }
    }

    const setAmountAccount = (rowSelected, value) => {
        const parsedValue = Number(value)
        const newValue =
            value === "" || isNaN(parsedValue) ? "" : Math.min(parsedValue, rowSelected.debt)

        setDataTable(prevData =>
            prevData.map(row =>
                row.id === rowSelected.id ? { ...row, amount_pay: newValue } : row
            )
        )

        setSelectedRows(prevSelected =>
            prevSelected.map(row =>
                row.id === rowSelected.id ? { ...row, amount_pay: newValue } : row
            )
        )

        const totalPaid = selectedRows.reduce((acc, row) => acc + (row.amount_pay || 0), 0)
        setTotalAmount((PaymentVoucher?.amount || 0) - totalPaid)
    }
    
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Grid container sx={{ width: 1050, padding: 2 }} spacing={2}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8
                    }}
                    tabIndex={-1}
                >
                    <CloseIcon />
                </IconButton>

                <Grid item xs={12}>
                    <Typography variant="h6">
                        Seleccionar cuentas a pagar
                    </Typography>
                </Grid>

                <Grid item xs={12} mb={2}>
                    <Divider />
                </Grid>

                <Grid item xs={6}>
                    <Paper elevation={0} sx={{ padding: 2, backgroundColor: "#f5f5f5" }}>
                        <Typography variant="subtitle1"><strong>Atajos de Teclado:</strong></Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Typography variant="body2">✅ <strong>F2:</strong> Confirmar pago</Typography>
                                <Typography variant="body2">⬆️ <strong>Shift:</strong> Buscar N° Folio</Typography>
                                <Typography variant="body2">❌ <strong>Esc:</strong> Cerrar formulario</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2">↑↓ <strong>Flechas:</strong> Navegar entre cuentas</Typography>
                                <Typography variant="body2">⏎ <strong>Enter:</strong> Seleccionar</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                <Grid item xs={6}>
                    <Box
                        sx={{
                            backgroundColor: "#f5f5f5",
                            borderRadius: 2,
                            padding: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                        }}
                    >
                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="subtitle1" fontWeight="bold">Deuda total:</Typography>
                            <Typography variant="subtitle1" color="error">{moneyCL(totalDebt)}</Typography>
                        </Stack>

                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="subtitle1" fontWeight="bold">
                                Monto {PaymentVoucher?.idway_to_pay === 3 ? "en efectivo" : "del cheque"}:
                            </Typography>
                            <Typography variant="subtitle1" color="primary">{moneyCL(PaymentVoucher?.amount || 0)}</Typography>
                        </Stack>

                        <Stack direction="row" justifyContent="space-between">
                            <Typography variant="subtitle1" fontWeight="bold">Saldo disponible:</Typography>
                            <Typography variant="subtitle1" color="success">{moneyCL(totalAmount)}</Typography>
                        </Stack>
                    </Box>
                </Grid>


                <Grid item xs={6}>
                    <TextField
                        inputRef={searchRef}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => {
                            onSearch(e.target.value);
                            setPage(0)
                        }}
                        placeholder="Buscar..."
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                    <Button
                        onClick={onAdd}
                        className="btn-table"
                        sx={{ mt: "10px" }}
                        style={{ textTransform: 'none' }}
                        size='small'
                        tabIndex={-1}
                    >
                        Pagar
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer>
                        <Table stickyHeader size="small">
                            <TableHead className="table-header" >
                                <TableRow sx={{ height: '32px' }}>
                                    <StyledTableCell className="table-header-text" align="center">
                                        <Checkbox
                                            id={`checkbox_0`}
                                            sx={{ color: '#FFFFFF' }}
                                            onChange={selectAllRows}
                                            checked={allSelected}
                                            inputProps={{
                                                'aria-label': 'select all desserts',
                                            }}
                                        />
                                    </StyledTableCell>
                                    <StyledTableCell className="table-header-text" align="center">
                                        N° Folio
                                    </StyledTableCell>
                                    <StyledTableCell className="table-header-text" align="center">
                                        Forma de pago
                                    </StyledTableCell>
                                    <StyledTableCell className="table-header-text" align="center">
                                        Vencimiento
                                    </StyledTableCell>
                                    <StyledTableCell className="table-header-text" align="center">
                                        Total factura
                                    </StyledTableCell>
                                    <StyledTableCell className="table-header-text" align="center">
                                        Monto pagado
                                    </StyledTableCell>
                                    <StyledTableCell className="table-header-text" align="center">
                                        Saldo pendiente
                                    </StyledTableCell>
                                    <StyledTableCell className="table-header-text" align="center">
                                        Monto a pagar
                                    </StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {statusAccounts === ApiStatus.FETCHING ? (
                                    <TableRow>
                                        {
                                            [0, 1, 2, 3, 4, 5, 6, 7].map((row: any, i: any) => {
                                                return (
                                                    <TableCell key={i}>
                                                        <Skeleton sx={{ height: 20 }} animation="wave" variant="rectangular" />
                                                    </TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                ) : (
                                    dataTable?.length > 0 ? (
                                        dataTable?.map((row, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: selectedRows.some(r => r.id === row.id) ? '#e0f7fa' : 'inherit',
                                                    '&:focus-within': { backgroundColor: '#b2ebf2' }
                                                }}
                                            >
                                                <TableCell align="center">
                                                    <Checkbox
                                                        id={`checkbox_${index + 1}`}
                                                        sx={{ color: '#69ABC3' }}
                                                        checked={isSelected(row)}
                                                        onChange={() => onCheckbox(row)}
                                                        inputProps={{
                                                            'aria-label': 'select all desserts',
                                                        }}
                                                        inputRef={(el) => checkboxRefs.current[index] = el}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">{row.folio}</TableCell>
                                                <TableCell align="center">{row.way_to_pay}</TableCell>
                                                <TableCell align="center">{formatDate(row.deadline)}</TableCell>
                                                <TableCell align="center">{moneyCL(row.total)}</TableCell>
                                                <TableCell align="center">{moneyCL(row.amount_paid)}</TableCell>
                                                <TableCell align="center">{moneyCL(row.debt)}</TableCell>
                                                <TableCell align="center">
                                                    <TextField
                                                        id={`amount_${index}`}
                                                        value={row.amount_pay}
                                                        onChange={(e) => setAmountAccount(row, e.target.value)}
                                                        size="small"
                                                        variant="outlined"
                                                        sx={{ width: 150 }}
                                                        InputProps={{
                                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                                        }}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Grid sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                                                    <div>{"Sin cuentas por cobrar"}</div>
                                                </Grid>
                                            </TableCell>
                                        </TableRow>
                                    )
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 10, 25, 100]}
                            count={totalRows}
                            rowsPerPage={perPage}
                            page={(page - 1)}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Filas por página"
                        />
                    </TableContainer>
                </Grid>
            </Grid>
            {showConfirmDialog && (
                <ModalConfirm
                    open={showConfirmDialog}
                    closeModal={() => { setShowConfirmDialog(false) }}
                    onConfirm={onConfirmPay}
                    status={statusAccounts === ApiStatus.FETCHING}
                    title="Confirmar pago"
                    text="¿Está seguro de realizar el pago?"
                />
            )}
        </Drawer>
    )
}